import request from './http';

export function lists(data = {}) {
  const params = {
    mold_id: data.mold_id || null,
    mold_ids: data.mold_ids || null,
    search: data.search || null,
    page: data.page || 1,
    page_size: data.page_size || 9,
  };
  return request.post('html/demand/index', params);
}

export function detail() { }

export function create(data) {
  return request.post('html/Release/demandRelease', data);
}

export function myRequirements(data) {
  return request.post('html/user/myDemand', data);
}

export function requirementDone(data) {
  return request.post('html/User/demandComplete', data);
}
export function getDemandForRandomStoreList(data) {
  return request.post('html/Release/getDemandForRandomStoreList', data);
}

// 获取节点
export function getProcess() {
  return request.get('followup/demand/process');
}

// 获取维护记录
export function getMaintainRecord(demandID, followID) {
  return request.get(`followup/demand/records?id=${demandID}&fid=${followID}`);
}
